import { FaGreaterThan, FaLessThan } from "react-icons/fa";
import "./Pagination.css";
import Select from "react-select";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Pagination = ({ currentPage, setCurrentPage, pagesData , startDate, endDate, getReconciliationData }) => {
  let token = useSelector(store => store.userReducer.token);
  let [totalOptions, setTotalOptions] = useState();

  useEffect(() => {
    const myData = [];
    for (let value = 1; value <= pagesData; value++) {
      myData.push({ value: value, label: value });
    }
    setTotalOptions(myData);
  }, [pagesData]);

  const handleChange = (selectedOption) => {
    setCurrentPage(selectedOption.value);
    getReconciliationData(token , selectedOption.value, startDate, endDate)
  };

  return (
    <div className="page-main">
      <div className="page-section">
        {currentPage > 1 && (
          <div
            className="greyButton"
            onClick={() => {
              setCurrentPage(currentPage - 1)
              getReconciliationData(token , currentPage - 1, startDate, endDate);
            }}
          >
            <FaLessThan />
          </div>
        )}
        <div className="pagination-button">{currentPage}</div>

        {currentPage < pagesData && (
          <div
            className="greyButton"
            onClick={() =>{ setCurrentPage(currentPage + 1)
              getReconciliationData(token , currentPage + 1, startDate, endDate)
            }
            }
          >
            <FaGreaterThan />
          </div>
        )}
      </div>

      {/* <div className="second-page">
        <Select
          value={{ value: currentPage, label: currentPage }}
          onChange={handleChange}
          options={totalOptions}
          className="sel-wide"
        />{" "}
        of {pagesData} Pages
      </div> */}
    </div>
  );
};
export default Pagination;
